// Weekday palette (Warm — locked per spec §6.1)
export const WEEKDAY_COLORS = [
  '#f59e0b',  // Mon
  '#ef4444',  // Tue
  '#ec4899',  // Wed
  '#8b5cf6',  // Thu
  '#06b6d4'   // Fri
]

export const WEEKDAYS = [
  { key: 'mon', short: 'Mon', full: 'Monday' },
  { key: 'tue', short: 'Tue', full: 'Tuesday' },
  { key: 'wed', short: 'Wed', full: 'Wednesday' },
  { key: 'thu', short: 'Thu', full: 'Thursday' },
  { key: 'fri', short: 'Fri', full: 'Friday' }
]

const UNKNOWN_CREW_COLOR = '#97a094'

// Returns 0..4 for Mon..Fri, null for Sat/Sun.
export function mondayOffset (date) {
  const dow = date.getDay()  // 0=Sun, 1=Mon, …, 6=Sat
  if (dow === 0 || dow === 6) return null
  return dow - 1
}

export function colorFor (stop, colorMode, crewColors) {
  if (colorMode === 'crew') {
    return crewColors[stop.crewId] || UNKNOWN_CREW_COLOR
  }
  return WEEKDAY_COLORS[stop.dayIndex]
}

// Small static landmark list for sidebar area labels.
// (HMI is in Phoenix metro; this is intentionally a Phoenix-area set.)
export const LANDMARKS = [
  { name: 'Phoenix', lat: 33.4484, lng: -112.0740 },
  { name: 'Glendale', lat: 33.5387, lng: -112.1859 },
  { name: 'Mesa', lat: 33.4152, lng: -111.8315 },
  { name: 'Scottsdale', lat: 33.4942, lng: -111.9261 },
  { name: 'Tempe', lat: 33.4255, lng: -111.9400 },
  { name: 'Chandler', lat: 33.3062, lng: -111.8413 },
  { name: 'Peoria', lat: 33.5806, lng: -112.2374 },
  { name: 'Gilbert', lat: 33.3528, lng: -111.7890 }
]

const LANDMARK_MAX_MI = 8

function haversineMi (lat1, lng1, lat2, lng2) {
  const toRad = d => d * Math.PI / 180
  const R = 3958.8
  const dLat = toRad(lat2 - lat1)
  const dLng = toRad(lng2 - lng1)
  const a = Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2
  return 2 * R * Math.asin(Math.sqrt(a))
}

export function areaName (lat, lng) {
  let best = null
  for (const lm of LANDMARKS) {
    const d = haversineMi(lat, lng, lm.lat, lm.lng)
    if (!best || d < best.d) best = { d, name: lm.name }
  }
  if (!best || best.d > LANDMARK_MAX_MI) return 'central area'
  return best.name
}
